import { slave as Gateway } from '@nsftx/seven-gravity-gateway';
import type { IntegratorResponseData, Token } from '@/types';
import { useAuthToken } from '@/composables/useAuthToken';

let instance: typeof Gateway;
let existingAuthToken: Token;

export default {
  init() {
    return new Promise((resolve) => {
      instance = Gateway({
        allowedOrigins: import.meta.env.VITE_APP_ALLOWED_ORIGINS,
        slaveId: import.meta.env.VITE_APP_SLAVE_ID,
        load: (message: { data: unknown }) => {
          resolve(message.data);
        }
      });

      this.setListeners();
    });
  },

  setListeners() {
    const { sevenToken, userId } = useAuthToken();

    instance?.subscribe(
      'User.AuthorizationChanged',
      (message: { data: IntegratorResponseData }) => {
        if (existingAuthToken !== message.data.auth.token) {
          existingAuthToken = message.data.auth.token;

          if (message.data.auth.user.id) {
            userId.value = message.data.auth.user.id;
          }
          sevenToken.value = message.data.auth.token;
        }
      }
    );
  },

  notifyAppLoaded() {
    instance?.sendMessage({
      action: 'Slave.Loaded'
    });
  }
};
